import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MzModalService } from "ng2-materialize";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { RouteDataService } from "../../services/route-data/route-data.service";
import { SessionService } from "../../services/session/session.service";
import { FeedbackModalComponent } from "../feedback-modal/feedback-modal.component";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  public env: any = environment;
  public showAnnotations: Observable<boolean> = this.sessionService
    .getRoles()
    .map((x) => x.indexOf("annotations") >= 0);
  public userIsAdmin: Observable<boolean> = this.sessionService
    .getRoles()
    .map((x) => x.indexOf("admin") >= 0);

  constructor(
    private sessionService: SessionService,
    public routeData: RouteDataService,
    private modalService: MzModalService
  ) {}

  public feedbackClicked() {
    this.modalService.open(FeedbackModalComponent);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/navigation/navigation.component.ts